import { combineReducers } from 'redux';

const routerReducer = (state = {}, action) => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
            return {
                ...state,
                location: action.payload
            };
        default:
            return state;
    }
};

import { reducer as postbackReducer } from './postback';
import { reducer as userReducer } from './user';
import { reducer as goalActionsReducer } from './goalActions';
import { reducer as offersReducer } from './offers';
import { reducer as utmsReducer } from './utms';
import { reducer as reactivationReducer } from './reactivation';
import { reducer as goalsReducer } from './goals';
import { reducer as postbackTestReducer } from './postbackTest';
import { reducer as postbackHistoryReducer } from './postbackHistory';
import { reducer as postbackParametersReducer } from './postbackParameters';
import { reducer as dashboardReducer } from './dashboard';
import { reducer as statisticsReducer } from './statistics';
import { reducer as linksReducer } from './links';
import { reducer as bannersReducer } from './banners';
import { reducer as landingsReducer } from './landings';
import { reducer as containersReducer } from './containers';
import { reducer as regionsReducer } from './regions';
import { reducer as publisherRanksReducer } from './publisherRanks';
import { reducer as publisherContactTypesReducer } from './publisherContactTypes';
import { reducer as publisherTimezonesListReducer } from './publisherTimezonesList';
import { reducer as currencyReducer } from './currency';
import { reducer as goalEntriesReducer } from './goalEntries';
import { reducer as publisherPayoutsReducer } from './publisherPayouts';
import { reducer as paymentMethodsReducer } from './paymentMethods';
import { reducer as paymentSystemsReducer } from './paymentSystems';
import { reducer as allowPaymentSystemsReducer } from './allowPaymentSystems';
import { reducer as publisherAccountEntriesReducer } from './publisherAccountEntries';
import { reducer as currencyRatiosReducer } from './currencyRatios';
import { reducer as paymentDetailsReducer } from './paymentDetails';
import { reducer as dynamicSegmentReducer } from './dynamicSegment';
import { reducer as conversionsReducer } from './conversions';
import { reducer as conversionsTotalReducer } from './conversionsTotal';
import { reducer as advertisersReducer } from './advertisers';
import { reducer as periodsReducer } from './periods';
import { reducer as financeOperationsReducer } from './financeOperations';
import { reducer as paceProgressReducer } from './paceProgress';
import { reducer as serverStorageReducer } from './serverStorage';
import { reducer as selectGoalActionsReducer } from './selectGoalActions';
import { reducer as notificationReducer } from './notification';
import { reducer as aggregationReducer } from './aggregation';
import { reducer as conversionUserInfoReducer } from './conversionUserInfo';
import { reducer as infoDocsReducer } from './infoDocs';
import { reducer as isNavExtended } from './isNavExtended';

const reducer = combineReducers({
    routing: routerReducer,
    user: userReducer,
    banners: bannersReducer,
    landings: landingsReducer,
    containers: containersReducer,
    conversions: conversionsReducer,
    conversionsTotal: conversionsTotalReducer,
    advertisers: advertisersReducer,
    periods: periodsReducer,
    financeOperations: financeOperationsReducer,
    currency: currencyReducer,
    currencyRatios: currencyRatiosReducer,
    dashboard: dashboardReducer,
    dynamicSegment: dynamicSegmentReducer,
    goalActions: goalActionsReducer,
    goalEntries: goalEntriesReducer,
    goals: goalsReducer,
    links: linksReducer,
    offers: offersReducer,
    utms: utmsReducer,
    reactivation: reactivationReducer,
    paceProgress: paceProgressReducer,
    paymentMethods: paymentMethodsReducer,
    paymentDetails: paymentDetailsReducer,
    paymentSystems: paymentSystemsReducer,
    allowPaymentSystems: allowPaymentSystemsReducer,
    postbackHistory: postbackHistoryReducer,
    postbackParameters: postbackParametersReducer,
    postbackTest: postbackTestReducer,
    postbacks: postbackReducer,
    publisherAccountEntries: publisherAccountEntriesReducer,
    publisherContactTypes: publisherContactTypesReducer,
    publisherTimezonesList: publisherTimezonesListReducer,
    publisherPayouts: publisherPayoutsReducer,
    publisherRanks: publisherRanksReducer,
    regions: regionsReducer,
    selectGoalActions: selectGoalActionsReducer,
    statistics: statisticsReducer,
    serverStorage: serverStorageReducer,
    notification: notificationReducer,
    aggregation: aggregationReducer,
    conversionUserInfo: conversionUserInfoReducer,
    infoDocs: infoDocsReducer,
    isNavExtended: isNavExtended,
});

export default reducer;
